import Brand from "../../../shared/components/Brand";

export default function PlanHeader() {
  return (
    <div className="w-full fixed p-4 bg-main-dark z-50">
      <Brand size="lg" />
    </div>
  );
}
